/**
 * Real people or the demo group — for an account that can see both (M46).
 * Brian: "I need to keep the real people separate from the fake people."
 * Hidden for everyone who sees only one lane.
 */
import { setLane } from '../lib/lane.js';

export function LanePicker({ tenant, tenants, onChange }) {
  if (!tenants || tenants.length < 2) return null;
  return (
    <label className="lane-picker">
      <span className="muted">Showing </span>
      <select
        value={tenant?.id ?? ''}
        onChange={(e) => {
          setLane(e.target.value);
          onChange?.(e.target.value);
        }}
        aria-label="Which organisation to show"
      >
        {tenants.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
            {t.demo ? ' — demo group' : ' — real people'}
          </option>
        ))}
      </select>
    </label>
  );
}

export default LanePicker;
